// FileUpload.js
import React, { useRef, useState } from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Iconify from "../iconify/Iconify";

const FileUpload = ({ getFile }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const inputFile = useRef(null);

  const handleClear = () => {
    setSelectedFile(null);
  };

  const handleFileChange = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    getFile(file);
    setSelectedFile(file);
  };

  const handleDragEnter = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);

    const file = event.dataTransfer.files[0];
    if (file) {
      getFile(file);
      setSelectedFile(file);
    }
  };

  const handleButtonClick = () => {
    // Trigger file input click on button click
    // document.getElementById("file-input").click();
    inputFile.current.click();
  };

  return (
    <Box
      onClick={!selectedFile && handleButtonClick}
      onDragEnter={handleDragEnter}
      onDragOver={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      display="flex"
      flexDirection="column"
      justifyContent="center" // Center the contents vertically
      alignItems="center" // Center the contents horizontally
      sx={{
        border: isDragging ? "2px dashed #2196f3" : "2px dashed #ccc",
        borderRadius: "8px",
        padding: "16px",
        textAlign: "center",
        cursor: "pointer",
        marginTop: "16px",
        width: "100%",
        minHeight: "200px",
      }}
    >
      <input
        type="file"
        accept="*"
        onChange={handleFileChange}
        style={{ display: "none" }}
        id="file-input"
        ref={inputFile}
      />
      {selectedFile && (
        <Box sx={{ display: "flex", alignItems: "center", marginTop: "8px" }}>
          {/* You can customize the preview based on the file type */}
          {selectedFile.type.startsWith("image/") && (
            <img
              src={URL.createObjectURL(selectedFile)}
              alt={selectedFile.name}
              style={{ maxWidth: "400px", maxHeight: "100%" }}
            />
          )}
          {/* Add additional conditions for other file types if needed */}
        </Box>
      )}
      <label htmlFor="file-input">
        <Typography
          variant="h6"
          component="div"
          sx={{
            color: isDragging ? "#2196f3" : "inherit",
            marginBottom: "8px",
          }}
        >
          {selectedFile
            ? `Ausgewählte Datei: ${selectedFile.name}`
            : "Hier klicken oder Datei hierherziehen"}
        </Typography>
      </label>
      <div>
        <Button
          variant="contained"
          startIcon={<Iconify icon="subway:file-11" />}
          onClick={handleButtonClick}
        >
          Datei auswählen
        </Button>
        <Button
          variant="contained"
          startIcon={<Iconify icon="ph:trash-bold" />}
          onClick={handleClear}
          disabled={!selectedFile}
          sx={{ marginLeft: "8px" }}
        >
          Zurücksetzen
        </Button>
      </div>
    </Box>
  );
};

export default FileUpload;
